import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 120 121",
  "content": "<symbol viewBox=\"0 0 120 121\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\">\n<rect width=\"9.6\" height=\"57.6\" rx=\"1\" transform=\"matrix(1 0 0 -1 43.1992 89.1885)\" fill=\"currentColor\" />\n<rect width=\"9.6\" height=\"57.6\" rx=\"1\" transform=\"matrix(1 0 0 -1 68.4004 89.1885)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol